import React from 'react';
import { Box } from '@material-ui/core';

const SettlementInfo = ({ title, value }) => {

  return (
    <Box
      mr="20px"
      color="#888888"
    >
      <Box
        mb="4px"
      >
        {title}
      </Box>
      <Box
        minWidth="120px"
        minHeight="18px"
        px="12px"
        py="4px"
        border="1px solid #cccccc"
      >
        {value}
      </Box>
    </Box>
  )
}

export default SettlementInfo;